import type { ReactNode } from "react";
import React from "react";

import { Skeleton } from "@/components/ui/skeleton";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";

type TabItem = {
  value: string;
  icon: ReactNode;
  label: string;
};

export const FeedWrapperTabs = ({ tabItems }: { tabItems: TabItem[] }) => {
  return (
    <TabsList
      className="
        unforce-radius flex w-full flex-wrap border-0 py-2
        shadow-[0_-1px_0_0_var(--border),0_1px_0_0_var(--border)]
        sm:p-0
        [&>[data-active]>span]:inline-flex
      "
    >
      {tabItems.map((item) => (
        <TabsTrigger key={item.value} value={item.value} className="flex gap-2">
          {item.icon}
          <span
            className="
              hidden w-full max-w-[120px] truncate
              sm:inline-flex
            "
          >
            {item.label}
          </span>
        </TabsTrigger>
      ))}
    </TabsList>
  );
};

export const FeedWrapperTabsSkeleton = ({
  tabItems,
  skeletonCount = tabItems.length,
}: {
  tabItems: TabItem[];
  skeletonCount?: number;
}) => {
  return (
    <div
      className="
        unforce-radius flex w-full items-center justify-center gap-x-4 p-0
        shadow-[0_-1px_0_0_var(--border),0_1px_0_0_var(--border)]
      "
    >
      {Array.from({ length: skeletonCount }, (_, index) => (
        <Skeleton
          className="
            my-2 size-[30px] rounded-full
            sm:h-[18px] sm:w-[100px]
          "
          key={index}
        />
      ))}
    </div>
  );
};
